export function initialDecisions(groups) {
  const decisions = {}
  for (const g of groups) for (const f of g.files) decisions[f.fileId] = f.fileId === g.referenceFileId ? 'keep' : 'exclude'
  return decisions
}

export const decide = (decisions, fileId, decision) => ({ ...decisions, [fileId]: decision })

export function keepAll(group, decisions) {
  const kept = { ...decisions }
  for (const f of group.files) kept[f.fileId] = 'keep'
  return kept
}

export const excludedIds = (groups, visited, decisions) =>
  groups.flatMap((g, i) => (visited.has(i) ? g.files.map(f => f.fileId).filter(id => decisions[id] === 'exclude') : []))

export const allExcluded = (group, decisions) => group.files.every(f => decisions[f.fileId] === 'exclude')

export function initialPanes(group) {
  const other = group.files.find(f => f.fileId !== group.referenceFileId)
  return { left: group.referenceFileId, right: other?.fileId }
}

export function showIn(panes, side, fileId) {
  const other = side === 'left' ? 'right' : 'left'
  if (panes[side] === fileId) return panes
  if (panes[other] === fileId) return { [side]: fileId, [other]: panes[side] }
  return { ...panes, [side]: fileId }
}
